module.exports = __webpack_public_path__ + "assets/apple-touch-icon-57-prod-d3e325.png";